const SCHEDULE_FILTER_KEYS = new Set(["all", "upcoming", "completed"]);
const VISIBLE_SCHEDULE_STATUSES = new Set(["upcoming", "completed"]);

export function getScheduleFilterFromSearch(search) {
  const category = new URLSearchParams(search).get("category");
  return SCHEDULE_FILTER_KEYS.has(category) ? category : "all";
}

export function filterSchedulesByCategory(schedules, category) {
  const source = Array.isArray(schedules) ? schedules : [];
  if (category === "all") return source.filter((schedule) => VISIBLE_SCHEDULE_STATUSES.has(schedule?.status));
  return source.filter((schedule) => schedule?.status === category);
}

export function getScheduleFilterCount(category, summary) {
  if (category === "all") return Math.max(0, Number(summary?.totalCount) || 0);
  if (category === "upcoming") return Math.max(0, Number(summary?.remainingCount) || 0);
  if (category === "completed") return Math.max(0, Number(summary?.completedCount) || 0);
  return 0;
}
